import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const STATUS = {
  ok: { label: 'Disponível', variant: 'success' },
  partial: { label: 'Fecha com desvios', variant: 'warning' },
  unavailable: { label: 'Indisponível', variant: 'secondary' }
};

export function PresetPicker({ presets, value, onChange }) {
  return (
    <div
      role="radiogroup"
      className="grid grid-cols-1 gap-3 sm:grid-cols-2"
    >
      {presets.map(preset => {
        const status = STATUS[preset.availability?.status] || STATUS.unavailable;
        const disabled = preset.availability?.status === 'unavailable';
        const selected = value === preset.key;
        return (
          <button
            key={preset.key}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-disabled={disabled}
            data-preset={preset.key}
            onClick={() => !disabled && onChange(preset.key)}
            className={cn(
              'flex flex-col gap-2 rounded-lg border p-4 text-left transition-[border-color,background-color,transform] duration-150 ease-out-strong',
              selected ? 'bg-primary/5 border-primary' : 'border-border',
              disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-neutral-lightest active:scale-[0.97]'
            )}
          >
            <span className="text-sm font-medium">{preset.label}</span>
            <span className="flex items-center gap-2 text-xs text-muted-foreground">
              {preset.total} questões
              <Badge variant={status.variant}>{status.label}</Badge>
            </span>
          </button>
        );
      })}
    </div>
  );
}
